import {
  Box,
  Tooltip,
  Zoom,
} from '@mui/material';
import dynamic from "next/dynamic";
const ReactQuill = dynamic(import('react-quill'), { ssr: false })
import 'react-quill/dist/quill.snow.css';
import { useFormikContext } from 'formik';
import React from 'react';

type ReactQuillFieldProps = {
  id: string;
  name: string;
  label: string;
  tooltiptitle: string;
};

export default function ReactQuillField(props: ReactQuillFieldProps) {
  const { label, name, tooltiptitle = '' } = props;
  const formik = useFormikContext();
  const { value } = formik.getFieldProps(name);

  return (
    <Tooltip
      title={tooltiptitle}
      TransitionComponent={Zoom}
      TransitionProps={{ timeout: 300 }}
      placement="bottom"
      arrow
    >
      <Box style={{ zIndex: 4, position: 'relative' }}>
        <label style={{ display: "block", marginBottom: 5 }}>{label}</label>
        <ReactQuill
          value={value}
          onChange={(changedValue: string) => {
            formik.setFieldValue(name, changedValue)
          }}
        />
      </Box>
    </Tooltip>

  );
}
